import React from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/basicInfo.scss";
import { companyNumberFormatter, phoneNumberFormatter, thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

const BasicInfoView = ({ irBasicInfo }) => {
	const { t } = useTranslation();
	return (
		<>
			{/*기본정보 view*/}
			<div className="basicInfo-view">
				<div className="date">
					{irBasicInfo?.regDate ? irBasicInfo?.regDate.substring(0, 10) : "-"}
				</div>
				<h2 className="ir-title">
					{irBasicInfo?.regDate.substring(0, 4)} <b>{irBasicInfo?.name}</b>{" "}
					{t("pages.investment.InvestEvalPage.detail.modal.basicInfo.irTitle")}
				</h2>
				<form className="data-form">
					<section className="input-group-section">
						<h3 className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.sectionTitle"
							)}
						</h3>
						<div className="c__form horiz data-view">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label01"
									)}
								</label>
								<div className="f__control">
									{companyNumberFormatter(irBasicInfo?.regNum)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label02"
									)}
								</label>
								<div className="f__control">{irBasicInfo?.name}</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label03"
									)}
								</label>
								<div className="f__control">{irBasicInfo?.ceoName}</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label04"
									)}
								</label>
								<div className="f__control">
									{irBasicInfo?.type === "PERSONAL"
										? t(
												"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.control01"
										  )
										: t(
												"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.control02"
										  )}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label05"
									)}
								</label>
								<div className="f__control">
									{irBasicInfo?.bizType}
									{irBasicInfo?.bizType && irBasicInfo?.bizStatus && "/"}
									{irBasicInfo?.bizStatus}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label06"
									)}
								</label>
								<div className="f__control">
									{irBasicInfo?.estDate.substring(0, 10)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label07"
									)}
								</label>
								<div className="f__control">
									{thousandFormatter(irBasicInfo?.employeeNum)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label08"
									)}
								</label>
								<div className="f__control">
									{companyNumberFormatter(irBasicInfo?.regNum)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label09"
									)}
								</label>
								<div className="f__control">
									{irBasicInfo?.address + irBasicInfo?.addressDetail}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label10"
									)}
								</label>
								<div className="f__control">{irBasicInfo?.homepage}</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section1.label11"
									)}
								</label>
								<div className="f__control">
									{phoneNumberFormatter(irBasicInfo?.ceoContact)}
								</div>
							</div>
						</div>
					</section>
					<section className="input-group-section">
						<h3 className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.sectionTitle"
							)}
						</h3>
						<div className="c__form horiz data-view">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.label01"
									)}
								</label>
								<div className="f__control">
									{thousandFormatter(irBasicInfo?.capital)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.label02"
									)}
								</label>
								<div className="f__control">
									{thousandFormatter(irBasicInfo?.faceValue)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.label03"
									)}
								</label>
								<div className="f__control">
									{thousandFormatter(irBasicInfo?.totalStock)}
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.label04"
									)}
								</label>
								<div className="f__control">{irBasicInfo?.settlement}</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section2.label05"
									)}
								</label>
								<div className="f__control">
									{thousandFormatter(irBasicInfo?.comValue)}
								</div>
							</div>
						</div>
					</section>
					<section>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label01"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irBasicInfo?.fundUse}
										readOnly
									/>
								</div>
							</div>
							<div className="f__group">
								<label className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label02"
									)}
								</label>
								<div className="f__control">
									<textarea
										className="c__textarea f__item"
										value={irBasicInfo?.exitPlan}
										readOnly
									/>
								</div>
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<label className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</label>
								{irBasicInfo?.IRBasicInfoAttraction?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li>{d.date.substring(0, 10)}</li>
										<li className="attraction-name">{d.content}</li>
										<li className="attraction-price">
											{thousandFormatter(d.value)}
										</li>
									</ul>
								))}
							</div>
							<div className="f__group">
								<label className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label04"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</label>
								{irBasicInfo?.IRBasicInfoSubsidy?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li>{d.date.substring(0, 10)}</li>
										<li className="attraction-name">{d.content}</li>
										<li className="attraction-price">
											{thousandFormatter(d.value)}
										</li>
									</ul>
								))}
							</div>
						</div>
						<div className="seal-area">
							<span className="seal-label">Signature</span>
							<div className="seal-uploader">
								<img
									src={irBasicInfo?.sign}
									alt={t(
										"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.imageAlt"
									)}
								/>
							</div>
						</div>
					</section>
				</form>
			</div>
		</>
	);
};

export default BasicInfoView;
